var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastSuccessLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#32BEA6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zm0 3.871c8.914 0 16.129 7.214 16.129 16.129 0 8.914-7.214 16.129-16.129 16.129-8.914 0-16.129-7.214-16.129-16.129 0-8.914 7.214-16.129 16.129-16.129m11.307 10.505l-1.818-1.832c-.376-.38-.989-.382-1.368-.005l-11.4 11.308-4.821-4.862c-.377-.379-.99-.381-1.369-.005l-1.832 1.817c-.38.377-.382.99-.006 1.369l7.321 7.38c.377.38.99.382 1.369.006L31.3 15.745c.38-.376.382-.99.006-1.369z",
    transform: "translate(-2837 -3736) translate(2727 3700) translate(110 36)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccessLarge);
export default __webpack_public_path__ + "static/media/toast-success-large.f62798beaefd4a967697f8ce8e12a7d1.svg";
export { ForwardRef as ReactComponent };